import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/auth/Login'
import Logout from '@/auth/Logout'

// Containers
import Full from '@/containers/Full'

// Views

import RunScan from '@/views/RunScan'
import APIDemo from '@/views/APIDemo'
import DMVFees from '@/views/DMVFees'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/RunScan',
      name: 'Home',
      component: Full,
      children: [
        {
          path: '/RunScan',
          name: 'Single Term Scan',
          component: RunScan,
          meta: { roles: ['User', 'Admin'] },
        },
        {
          path: '/APIDemo',
          name: 'mPencil Scan ',
          component: APIDemo,
          meta: { roles: ['User', 'Admin'] }
        },
        {
          path: '/DMVFees',
          name: 'DMV Fees',
          component: DMVFees,
          meta: { roles: ['User', 'Admin'] }
        }
      ],
      meta: { roles: ['User', 'Admin'] }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    }
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js